import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { AlertTriangleIcon, XCircleIcon } from 'lucide-react';
export function ProblemSection() {
  const failedAttempts = ['Rutinas genéricas sin fundamento técnico.', 'PDFs sueltos sin estructura ni análisis.', 'Improvisar sin un criterio claro para justificar cada ejercicio.'];
  return <section className="py-10 bg-card/50 border-y border-card-border relative overflow-hidden" data-id="element-192">
      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-193">
        <FadeIn data-id="element-194">
          <div className="text-center mb-10" data-id="element-195">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-red-500/10 text-red-500 mb-6" data-id="element-196">
              <AlertTriangleIcon className="w-8 h-8" data-id="element-197" />
            </div>
            <h2 className="text-3xl md:text-4xl font-black mb-6" data-id="element-198">
              Dejá de depender de la intuición
            </h2>
            <p className="text-lg text-gray-400 max-w-2xl mx-auto leading-relaxed" data-id="element-199">
              Te preguntan{' '}
              <span className="text-primary font-semibold" data-id="element-200">
                "¿Por qué este ejercicio?"
              </span>{' '}
              y no siempre tenés la justificación técnica lista. No es que no
              sepas entrenar — es que sin una base estructurada, terminás
              improvisando.{' '}
              <strong className="text-white font-semibold" data-id="element-201">
                Tus alumnos lo notan. Y eso frena tu crecimiento profesional.
              </strong>
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-202">
          <div className="bg-card border border-red-500/20 rounded-2xl p-6 md:p-8" data-id="element-203">
            <h3 className="text-xl font-bold mb-5 text-center text-red-400" data-id="element-204">
              Lo que ya intentaste y no funcionó
            </h3>
            <ul className="space-y-3" data-id="element-205">
              {failedAttempts.map((attempt, index) => <li key={index} className="flex items-center gap-4 p-3 rounded-xl bg-background/50 border border-card-border" data-id="element-206">
                  <XCircleIcon className="w-5 h-5 text-red-500 shrink-0" data-id="element-207" />
                  <span className="text-gray-300" data-id="element-208">{attempt}</span>
                </li>)}
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}